import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import ArrowLeftIcon from 'app/assets/svgs/ArrowLeftIcon';
import { resetFromFinalEdit } from 'app/domain/loan/slice';
import { RoutePath } from 'app/Routing/constants';

interface BackButtonProps {
  url: string;
}

const BackButton = ({ url }: BackButtonProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const handleClick = () => {
    if (url === 'back') {
      navigate(-1);
      return;
    }
    if (location.pathname !== RoutePath.loanEstimation) {
      dispatch(resetFromFinalEdit());
    }
    navigate(url, { replace: true });
  };

  return (
    <div
      className="flex absolute inset-y-0 left-0"
      data-testid="backbutton-component"
    >
      <button
        onClick={handleClick}
        className="flex self-center w-8 h-8 items-center justify-center dark:text-grayscale-lighter"
      >
        <ArrowLeftIcon />
      </button>
    </div>
  );
};

export default BackButton;
